import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HomeComponent } from './pages/home/home.component';
import { RegisterComponent } from './pages/register/register.component';
import { AboutComponent } from './pages/about/about.component';
import { DepartmentComponent } from './pages/department/department.component';
import { FacultyComponent } from './pages/faculty/faculty.component';
import { HeaderComponent } from './pages/header/header.component';
import { EventComponent } from './pages/event/event.component';
import { CoursComponent } from './pages/cours/cours.component';
import { EducationSystemComponent } from './pages/education-system/education-system.component';
import { ReserchDetailsComponent } from './pages/reserch-details/reserch-details.component';
import { BachelorStudyComponent } from './pages/bachelor-study/bachelor-study.component';
import { NewsListComponent } from './pages/news-list/news-list.component';
import { ReserchListComponent } from './pages/reserch-list/reserch-list.component';
import { CoursesStudyComponent } from './pages/courses-study/courses-study.component';
import { MasterStudyComponent } from './pages/master-study/master-study.component';
import { NewsDetailsComponent } from './pages/news-details/news-details.component';
import { SearchResultComponent } from './pages/search-result/search-result.component';
import { FacultyNewsListingComponent } from './pages/faculty-news-listing/faculty-news-listing.component';
import { FacultyEventsComponent } from './pages/faculty-events/faculty-events.component';
import { EventDetailsComponent } from './pages/event-details/event-details.component';
import { CourseRegisterComponent } from './pages/course-register/course-register.component';
import { CourseRegisterConfirmComponent } from './pages/course-register-confirm/course-register-confirm.component';
import { ContactUsComponent } from './pages/contact-us/contact-us.component';
import { AcadmyFormComponent } from './pages/acadmy-form/acadmy-form.component';
import { AcadmyCondtionsComponent } from './pages/acadmy-condtions/acadmy-condtions.component';
import { ReserchFacultyComponent } from './pages/reserch-faculty/reserch-faculty.component';
import { InstractorsComponent } from './pages/instractors/instractors.component';
import { AcadmyInstractorComponent } from './pages/acadmy-instractor/acadmy-instractor.component';
import { ConstructionComponent } from './pages/construction/construction.component';
import { ConstructionFeedComponent } from './pages/construction-feed/construction-feed.component';
import { InstrctorDetailsComponent } from './pages/instrctor-details/instrctor-details.component';
import { RootRedirectGuard } from './guards/root-redirect.guard';
import { EqacComponent } from './pages/eqac/eqac.component';

const routes: Routes = [
  { path: '', component: FacultyComponent, canActivate: [RootRedirectGuard], data: { title: 'المعاهد' } },
  { path: 'home', component: HomeComponent, data: { title: 'الصفحة الرئيسية' } },
  { path: 'register', component: RegisterComponent, data: { title: 'التسجيل' } },
  { path: 'about', component: AboutComponent, data: { title: 'عن الأكاديمية' } },
  { path: 'department/:id', component: DepartmentComponent, data: { title: 'الأقسام العلمية' } },
  { path: 'faculty', component: FacultyComponent, data: { title: 'المعاهد' } },
  { path: 'header', component: HeaderComponent, data: { title: 'القائمة' } },
  { path: 'events', component: EventComponent, data: { title: 'الفعاليات' } },
  { path: 'course_details', component: CoursComponent, data: { title: 'تفاصيل المقرر' } },
  { path: 'Education_system', component: EducationSystemComponent, data: { title: 'النظام التعليمي' } },
  { path: 'research_details/:id', component: ReserchDetailsComponent, data: { title: 'تفاصيل البحث' } },
  { path: 'bachelor_study', component: BachelorStudyComponent, data: { title: 'دراسات البكالوريوس' } },
  { path: 'news_list', component: NewsListComponent, data: { title: 'الأخبار' } },
  { path: 'research_list', component: ReserchListComponent, data: { title: 'الدراسات والبحوث' } },
  { path: 'courses_study', component: CoursesStudyComponent, data: { title: 'الدراسات الحرة' } },
  { path: 'master_study', component: MasterStudyComponent, data: { title: 'الدراسات العليا' } },
  { path: 'news_details/:id', component: NewsDetailsComponent, data: { title: 'تفاصيل الخبر' } },
  { path: 'search_result', component: SearchResultComponent, data: { title: 'نتائج البحث' } },
  { path: 'faculty_news_listing', component: FacultyNewsListingComponent, data: { title: 'أخبار المعهد' } },
  { path: 'faculty_Events/:id', component: FacultyEventsComponent, data: { title: 'فعاليات المعهد' } },
  { path: 'event_Details/:id', component: EventDetailsComponent, data: { title: 'تفاصيل الفعالية' } },
  { path: 'course_Register', component: CourseRegisterComponent, data: { title: 'تسجيل في مقرر' } },
  { path: 'course_Register_Confirm', component: CourseRegisterConfirmComponent, data: { title: 'تأكيد التسجيل' } },
  { path: 'contact_us', component: ContactUsComponent, data: { title: 'اتصل بنا' } },
  { path: 'academy_register', component: AcadmyFormComponent, data: { title: 'التقديم للأكاديمية' } },
  { path: 'academy_conditions', component: AcadmyCondtionsComponent, data: { title: 'شروط القبول' } },
  { path: 'instractors', component: InstractorsComponent, data: { title: 'أعضاء هيئة التدريس' } },
  { path: 'academy_instractors', component: AcadmyInstractorComponent, data: { title: 'أعضاء هيئة التدريس' } },
  { path: 'eqac', component: EqacComponent, data: { title: 'مركز ضمان الجودة' } },
  { path: 'constrction/:id', component: ConstructionComponent, data: { title: 'إنشاءات الأكاديمية' } },
  { path: 'constrction/:id/news', component: ConstructionFeedComponent, data: { type: 'news', title: 'أخبار الإنشاءات' } },
  { path: 'constrction/:id/events', component: ConstructionFeedComponent, data: { type: 'events', title: 'فعاليات الإنشاءات' } },
  { path: 'instractors_details/:id/:name', component: InstrctorDetailsComponent, data: { title: 'بيانات عضو هيئة التدريس' } },
  { path: 'research_faculty_list', component: ReserchFacultyComponent, data: { title: 'بحوث المعهد' } },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
